import styled from 'styled-components'

import { BaseAlert } from './BaseAlert'
import { IconComponentStyled } from '@ui/elements/Icon/styles/IconComponentStyled'

export const InfoAlert = styled(BaseAlert)`
  background-color: ${(props) => props.theme.colors.alert.info.background};

  border-color: ${(props) => props.theme.colors.alert.info.border};

  ${IconComponentStyled} {
    color: ${(props) => props.theme.colors.alert.info.icon};
  }
`

InfoAlert.displayName = 'InfoAlert'
